import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ControlType, SimpleInputModule } from '@hglobal/common';
import { ShopOrder, FormType, InternationalOrderForm } from '@pt/models';

@Component({
  selector: 'pt-delivery-international',
  templateUrl: './international.component.html',
  styleUrls: ['./international.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    SimpleInputModule,
  ],
})
export class InternationalComponent implements OnInit {
  readonly #formBuilder = inject(FormBuilder);

  order = input.required<ShopOrder>();
  form = input.required<FormType<InternationalOrderForm, 'delivery'>>();

  readonly controlTypes = ControlType;

  ngOnInit(): void {
    this.form().removeControl('delivery');
    this.form().addControl(
      'delivery',
      this.#formBuilder.group({
        country: ['', Validators.required],
        postcode: [<any>null, Validators.required],
        regionState: ['', Validators.required],
        city: ['', Validators.required],
        address: ['', Validators.required],
        apartment: '',
        postOffice: '',
        email: ['', Validators.required],
      }),
    );
  }
}
